module.exports = __webpack_public_path__ + "static/media/friendly-store-icon.66994f44.svg";